/**
 * File Name          : file-open-mode.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

export enum FILE_OPEN_MODE
{
	NA,
	NEW,
	EXISTING,
	ALWAYS,
	ALWAYS_OVERWRITE,
	ALWAYS_APPEND,
};